(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var COOKIE_NAME = 'mokosh_club_popup';
    var COOKIE_DAYS = 30;

    var getCookie = function (name) {
      var match = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
      );
      return match ? decodeURIComponent(match[1]) : null;
    };

    var setCookie = function (name, value, days) {
      var expires = new Date();
      expires.setDate(expires.getDate() + days);
      document.cookie =
        name + '=' + encodeURIComponent(value) + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
    };

    var isDesignMode = function () {
      return window.Shopify && Shopify.designMode;
    };

    var openPopup = function (el) {
      el.removeAttribute('hidden');
      el.classList.add('is-open');
      document.body.classList.add('club-popup-open');

      var closeBtn = el.querySelector('.club-popup__close');
      if (closeBtn) closeBtn.focus();

      if (!isDesignMode()) {
        setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
      }
    };

    var closePopup = function (el) {
      el.classList.remove('is-open');
      el.setAttribute('hidden', '');
      document.body.classList.remove('club-popup-open');
    };

    var initPopup = function (el) {
      if (!el || el.dataset.clubPopupReady === 'true') return;
      el.dataset.clubPopupReady = 'true';

      var delay = parseFloat(el.getAttribute('data-delay'));
      if (isNaN(delay) || delay < 0) delay = 5;

      el.querySelectorAll('[data-club-popup-close]').forEach(function (control) {
        control.addEventListener('click', function () {
          closePopup(el);
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && el.classList.contains('is-open')) {
          closePopup(el);
        }
      });

      if (isDesignMode()) {
        openPopup(el);
        return;
      }

      if (getCookie(COOKIE_NAME)) return;

      window.setTimeout(function () {
        openPopup(el);
      }, delay * 1000);
    };

    document.querySelectorAll('[data-club-popup]').forEach(initPopup);

    document.addEventListener('shopify:section:load', function (event) {
      var popup = event.target.querySelector('[data-club-popup]');
      if (popup) initPopup(popup);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
